export default __webpack_public_path__ + "static/media/show-earring-2.e6a9595a.webp";